import App from "./App";
import {useWeb3React} from "@web3-react/core";
import {Header, NotificationContainer} from '@airdao/ui-library';

import { WalletConnect } from '@web3-react/walletconnect-v2';
import {
  useAuthorization,
  useAutoLogin,
} from 'airdao-components-and-tools/hooks';
import {
  metamaskConnector,
  walletconnectConnector,
} from 'airdao-components-and-tools/utils';
import { ethers } from 'ethers';
import {useEffect, useState} from "react";
import 'react-toastify/dist/ReactToastify.css';

const readProvider = new ethers.providers.JsonRpcProvider(
  process.env.REACT_APP_RPC_URL,
);

const Layout = () => {
  const [balance, setBalance] = useState('0');
  const { account, connector } = useWeb3React();
  useAutoLogin(metamaskConnector);

  const { loginMetamask, loginWalletConnect, logout } = useAuthorization(
    metamaskConnector,
    walletconnectConnector,
  );
  const isLoaded = useAutoLogin(metamaskConnector);

  useEffect(() => {
    getBalance();
    readProvider.on('block', () => {
      getBalance();
    });
    return () => {
      readProvider.removeAllListeners('block');
    };
  }, [account, isLoaded]);

  const getBalance = async () => {
    if (!account) return;

    const bnBalance = await readProvider.getBalance(account);
    const numBalance = ethers.utils.formatEther(bnBalance);
    setBalance((+numBalance).toFixed(2));
  };

  return (
    <div>
      <Header
        loginMetamask={loginMetamask}
        loginWalletConnect={loginWalletConnect}
        account={account}
        disconnect={logout}
        balance={balance}
        connector={
          connector instanceof WalletConnect ? 'walletconnect' : 'metamask'
        }
      />
      <App />
      <NotificationContainer />
    </div>
  )
};
export default Layout;
